/*
  Restricted state
*/
export default {
  list: [],
  geofence: [],
  edittingId: undefined,
  type: 'restricted'
}
